export default "__VITE_ASSET__D_en9IQg__"